// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"88888af0","977":"4c6b8575"}[chunkId] + ".chunk.js";
};